import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import '@/lib/i18n';
import { App } from './App';

const root = document.getElementById('root');
if (!root) throw new Error('#root element missing');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
